// extracted by mini-css-extract-plugin
export var avatarContainer = "_3r-0";
export var gray = "_3r-f";
export var green = "_3r-c";
export var icon = "_3r-9";
export var image = "_3r-1";
export var lg = "_3r-6";
export var md = "_3r-5";
export var presenceDot = "_3r-b";
export var red = "_3r-d";
export var sm = "_3r-4";
export var status = "_3r-a";
export var xl = "_3r-7";
export var xs = "_3r-3";
export var xxl = "_3r-8";
export var xxs = "_3r-2";
export var yellow = "_3r-e";